import { render, staticRenderFns } from "./BugSupport.vue?vue&type=template&id=173ff3d6&"
import script from "./BugSupport.vue?vue&type=script&lang=js&"
export * from "./BugSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports